export default "__VITE_ASSET__DyHiE7Lm__"